import React, { useEffect } from "react";
import TemplateLayout from "../../../../../providers/TemplateLayout";
import { useDispatch } from "react-redux";
import { setTemplateText } from "../../../../../store/slices/endorsement.slice";
import { useAppSelector } from "../../../../../hooks/app";
import { getUser } from "../../../../../store/slices/auth-slice";
import { ROLES } from "../../../../../constants";

function FlightProficiencyPractical({ templateName }: { templateName: string }) {
    const user = useAppSelector(getUser)
    const [name, setName] = React.useState(user?.role === ROLES.STUDENT ? user?.firstname + " " + user?.lastname : '')
    const [test, setTest] = React.useState("")
    const dispatch = useDispatch()
    useEffect(() => {
        const templateText = `I certified that ${name} has received the required training in accordance with §61.107 and 61.109. . I have determined [he or she] is prepared for ${test} practical test.`
        dispatch(setTemplateText(templateText))
    }, [name, test, dispatch])
    return (
        <TemplateLayout templateName={templateName}>
            <div className="col-12 my-2">
                <label>Relevant FAR: 61.165(f)</label>
            </div>

            <div className="col-12 my-2">
                <p className="certificate_text">
                    I certified that <input type="text" onChange={(e) => setName(e.target.value)} value={name} /> has received the required training in accordance with §61.107 and 61.109. . I have determined [he or she] is prepared for <input type="text" onChange={(e) => setTest(e.target.value)} /> practical test.
                </p>
            </div>
        </TemplateLayout>
    );
}

export default FlightProficiencyPractical;
